import { deleteService, getService, postService } from 'services/comfiguraServiceApi';
import { IAttachment, IDownloadResponse, IPresignedUrlResponse, PresignedUrlProps } from './types';

export const assignFileToFigurant = async ({ attachments, backgroundActorId }: PresignedUrlProps): Promise<boolean> => {
  const newAttachments = attachments?.map(({ nomeDoArquivo, tipoDoConteudo, ...otherValues }) => ({
    fileName: nomeDoArquivo,
    fileType: tipoDoConteudo,
    ...otherValues,
  }));
  const fromToForGenerateUrl = newAttachments?.map(({ file, isInitial, ...restValues }) => ({
    ...restValues,
  }));

  const partialResponse = await postService('/urlpresigned', {
    backgroundActorId,
    path: 'figurantes/anexos/',
    attachments: fromToForGenerateUrl,
  });
  const attachmentsUpdated = await getAttachmentsBgActor(String(backgroundActorId));
  const responseTemporaryFile = partialResponse?.data as IPresignedUrlResponse[];

  const allInitialIds = newAttachments?.filter(item => !!item?.id)?.map(({ id }) => String(id));

  const newFiles = responseTemporaryFile?.filter(({ id }) => !allInitialIds?.includes(String(id)));

  const results = await Promise.allSettled(
    newFiles?.map(item => {
      const newItem = attachmentsUpdated?.find(({ id }) => String(id) == String(item?.id));
      const getDetail = newAttachments?.find(({ fileName }) => fileName == newItem?.originalName);

      fetch(item?.url, {
        body: getDetail?.file,
        method: 'PUT',
        headers: {
          'content-type': getDetail?.file?.type as string,
        },
      });
    })
  );

  const allsuccess = results?.every(result => result?.status == 'fulfilled');

  return allsuccess;
};

export const downloadFile = async (fileUrl: string): Promise<IDownloadResponse> => {
  const response = await postService('/download', {
    NomeDoArquivo: fileUrl,
  });

  return response.data;
};

export const getAttachmentsBgActor = async (BackgroundActorId: string): Promise<IAttachment[]> => {
  const response = await getService(`/background-actor/${BackgroundActorId}/attachments`);

  return response.data;
};

export const deleteAttachment = async (fileId: string): Promise<void> => await deleteService(`/attachments/${fileId}`);
